<div class="workspace full-height">
  <div class="row group-details-container">
    <div class="col-md-12 col-sm-12" *ngIf="!isRecentlyVisitedInfluencerGroup && influencerGroup && influencerGroup.influencer_group_id > 0">
      <group-details-breadcumb [influencerGroup]="influencerGroup"
                               [groupSetting]="influencerGroupSetting"
                               [totalResult]="totalInfluencer"
                               [searchString]="searchCriteria.searchString"
                               (searchTextEvent)="searchInfluencerByText($event)"
                               (updateGroupEvent)="updateGroupEvent($event)"
                               (editOrCreateProjectEvent)="editOrCreateProject($event)"
                               #GroupDetailsBreadcumb>
      </group-details-breadcumb>
    </div>
    <div class="col-md-12 col-sm-12" *ngIf="isRecentlyVisitedInfluencerGroup">
      <monthly-visited-breadcrumb [influencerGroup]="influencerGroup"
                                  [influencerList]="influencerList"
                                  [totalInfluencer]="totalInfluencer"
                                  (checkEvent)="selectAllInfluencer($event)">
      </monthly-visited-breadcrumb>
    </div>
    <div class="col-md-12 col-sm-12 mt-15px" *ngIf="!isRecentlyVisitedInfluencerGroup">
      <search-bar [countryList]="countryList" [platFormList]="platformList"
                  [influencerGroup]="influencerGroup"
                  [groupSearch]="searchCriteria"
                  [showSearchBar]="openSearchBar"
                  (checkEvent)="selectAllInfluencer($event)"
                  (searchEvent)="advanceSearchInfluencerList($event)"
                  [influencerGroupId]="influencerGroupId"
                  [isActiveDiscoverFollower]="isActiveDiscoverFollower"
      ></search-bar>
    </div>
    <div class="col-md-12 col-sm-12">
      <achoo-infinite-scroll [scrollDistance]="scrollDistance"
                             [scrollDistanceUp]="scrollUpDistance"
                             [infiniteScrollThrottle]="throttle"
                             (scrollDownEvent)="onScrollDown()">
        <div *ngIf="!isRecentlyVisitedInfluencerGroup">
          <div class="influencer-item-container" *ngFor="let pendingInfluencer of pendingInfluencerList">
            <influencer-item [influencer]="pendingInfluencer"
                              [influencerGroupId]="influencerGroupId"
                              (eventSelectInfluencer)="onSelectSingleInfluencer($event)"
                              (approveInfluencerEvent)="approveNewInfluencer($event)"
                              (deleteInfluencerEvent)="showWarningDeleteInfluencerPopup($event)"
                              (rejectSuggestedInfluencer)="onRejectSuggestedInfluencer($event)"></influencer-item>
          </div>
        </div>
        <div *ngIf="showFetchMoreBtn" class="d-flex flex-row flex-auto align-items-center justify-content-center">
          <button class="button gray fetch-more-pending-influencer-btn" (click)="fetchPendingInfluencerList()">{{'group_details.fetch_more_pending_influencer_btn' | translate}}</button>
        </div>
        <div class="influencer-item-container" *ngFor="let influencer of influencerList">
          <influencer-item [influencer]="influencer"
                           [influencerGroupId]="influencerGroupId"
                           [isRecentlyVisitedInfluencerGroup]="isRecentlyVisitedInfluencerGroup"
                           [isLoadingData]="isLoadingData"
                           (eventSelectInfluencer)="onSelectSingleInfluencer($event)"
                           (deleteInfluencerEvent)="showWarningDeleteInfluencerPopup($event)"></influencer-item>
        </div>
      </achoo-infinite-scroll>
      <div class="empty-message" *ngIf="showEmptyResultMessage">
        {{'group_details.empty_result' | translate}}
      </div>
    </div>
    <div class="col-md-12">
      <achoo-placeholder [placeholderId]="'groupDetailsInfluencerListHolder'" [normalPlaceholder]="true" [isFullscreenLoader]="false">
      </achoo-placeholder>
    </div>
  </div>
</div>
<div class="bottombar"
     [ngClass]="{'open': activeBottomBar === 'active', 'collapsed': activeBottomBar === 'inactive'}">
  <div class="row full-height">
    <div class="col-md-12 col-sm-12 d-flex">
      <bottombar-influencer-fragement class="d-flex flex-auto full-width"
                                      [influencerList]="previewInfluencerList"
                                      [influencerGroupId]="influencerGroupId"
                                      [influencerGroup]="influencerGroup"
                                      [influencerGroupList]="influencerGroupList"
                                      [campaignList]="campaignList"
                                      [isUsingForGroupDetail]="true"
                                      [isRecentlyVisitedInfluencerGroup]="isRecentlyVisitedInfluencerGroup"
                                      (beforeAddingPendingInfluencerToGroup)="beforeAddingPendingInfluencerToGroup($event)"
                                      (addPendingInfluencerToGroupError)="addPendingInfluencerToGroupError()"
                                      (closeBottomBarCallback)="closeBottonBar($event)"
                                      (openBottomBarCallback)="beforeActiveBottomBar()"
                                      (beforeUpdateGroupEvent)="beforeUpdateGroupEvent($event)"
                                      (afterUpdateGroupEvent)="afterUpdateGroupEvent($event)"
                                      (clearSelectionCallback)="clearSelectedInfluencers()"
                                      (openGroupSetting)="showHideGroupSettings()"
                                      (deleteInfluencerEvent)="deleteInfluencerFromBottomBar($event)"
                                      #BottombarInfluencerFragement>
      </bottombar-influencer-fragement>
    </div>
  </div>
</div>
<achoo-popup #WarningDeleteInfluencerDialog
             cancelBtnLabel="{{'common.btn.delete_confirm_cancel' | translate:{container : 'group'} }}"
             acceptBtnLabel="{{'common.btn.delete_confirm_ok' | translate}}"
             [isAlertPopup]="true"
             (acceptCallback)="deleteSelectedInfluencers()"
             (cancelCallback)="closeWarningDeleteInfluencerPopup()">
  <div class="d-flex flex-column flex-auto">
    <span>{{'group_details.influencer.delete_warning_message' | translate:
      {numOfInfluencer: numberInfluencerToDelete} }}</span>
  </div>
</achoo-popup>
<achoo-popup #AlertAPIError
             [isNotification]="true"
             modelTitle="{{'notification.error' | translate}}">
  <div class="d-flex flex-row flex-auto">
    <span>{{serverErrorMessage}}</span>
  </div>
</achoo-popup>

<achoo-popup #SuccessNotification
             [isNotification]="true"
             modelTitle="{{'notification.success' | translate}}">
  <div class="d-flex flex-row flex-auto">
    <span>{{successMessage}}</span>
  </div>
</achoo-popup>
<achoo-popup #AlertInfluencerApiFail
             acceptBtnLabel="{{'common.btn.ok' | translate}}"
             [isAlertPopup]="true"
             (acceptCallback)="closeErrorMsgModal()"
             (cancelCallback)="closeErrorMsgModal()">
  <span>{{'group_details.api_fail' | translate}}</span>
</achoo-popup>
<achoo-popup #UpdateInfluencerGroupError
             [isNotification]="true"
             modelTitle="{{'notification.error' | translate}}">
  <span>{{'new_group_settings.update_group_name_error' | translate}}</span>
</achoo-popup>
<achoo-popup #SelectAllInfluencers
             [isNotification]="true"
             modelTitle="{{'notification.notice' | translate}}">
  <span>{{'group_details.influencer.select_all' | translate:{selected_influencer: numberOfSelectedInfluencers} }}</span>
</achoo-popup>



// WEBPACK FOOTER //
// ./src/app/main/group-details/group-details.component.html